"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorReasonMessage = exports.errorReasonHttpStatusCode = exports.errorReasonToError = exports.ErrorWithReason = void 0;
const capitalize_1 = __importDefault(require("lodash/capitalize"));
const Constants_1 = require("../Constants");
class ErrorWithReason extends Error {
    constructor(message, reason, httpStatusCode) {
        super(message);
        this.reason = reason;
        this.httpStatusCode = httpStatusCode;
    }
    static unknownReason(message) {
        return new ErrorWithReason(message, 'UNKNOWN_EVENT_TYPE', errorReasonHttpStatusCode('UNKNOWN_EVENT_TYPE'));
    }
}
exports.ErrorWithReason = ErrorWithReason;
function errorReasonToError(reason, message) {
    return new ErrorWithReason(message !== null && message !== void 0 ? message : errorReasonMessage(reason), reason, errorReasonHttpStatusCode(reason));
}
exports.errorReasonToError = errorReasonToError;
function errorReasonHttpStatusCode(reason) {
    switch (reason) {
        case 'EMAIL_DOES_NOT_MATCH':
        case 'EMAIL_NOT_VERIFIED':
        case 'NOT_ACCOUNT_OWNER':
        case 'INVALID_TOKEN':
            return 401; // unauthenticated ("unauthorized")
        case 'DRIVER_NOT_FOUND':
        case 'USER_NOT_FOUND':
            return 404; // not found
        case 'ALREADY_CASHED_OUT':
        case 'CANNOT_CANCEL_TRIP_COMPLETE':
        case 'CANNOT_CHANGE_PADDING':
        case 'DELIVERY_ALREADY_EXISTS':
        case 'DUPLICATE_PARTICIPANTS':
        case 'NO_SERVICES_AVAILABLE':
        case 'TOO_EARLY_TO_CANCEL':
        case 'DRIVER_ALREADY_CREATED':
            return 409; // conflict
        case 'EXPIRED_COUPON':
        case 'NO_DRIVER_FOR_EARNINGS':
        case 'PADDING_TOO_LOW':
        case 'PADDING_TOO_HIGH':
        case 'PAYOUTS_DISABLED':
        case 'PAYOUTS_DISABLED_FOR_DRIVER':
        case 'UNKNOWN_EVENT_TYPE':
        case 'INVALID_COUPON_CODE':
        case 'INVALID_INPUT':
        case 'TRIP_NOT_PAYABLE':
        case 'SCHEDULED_TOO_SOON':
            return 422; // unprocessable entity
        default:
            return 500; // internal server error
    }
}
exports.errorReasonHttpStatusCode = errorReasonHttpStatusCode;
function errorReasonMessage(reason) {
    switch (reason) {
        case 'ALREADY_CASHED_OUT':
            return 'The trip has already been cashed out';
        case 'CANNOT_CANCEL_TRIP_COMPLETE':
            return "The trip can't be canceled because it is complete";
        case 'CANNOT_CHANGE_PADDING':
            return 'Padding cannot be changed less than 90 minutes before the event';
        case 'DELIVERY_ALREADY_EXISTS':
            return 'A delivery with that ID already exists';
        case 'DRIVER_ALREADY_CREATED':
            return 'Driver has already been created';
        case 'DUPLICATE_PARTICIPANTS':
            return 'Both participants have the same phone number. This will not work';
        case 'EMAIL_DOES_NOT_MATCH':
            return 'That email address does not match the one used to fill out the application';
        case 'EMAIL_NOT_VERIFIED':
            return 'Your email address has not yet been verified';
        case 'EZ_CATER_ERROR':
            return 'ezCater error';
        case 'NO_DRIVER_FOR_EARNINGS':
            return 'Job has no driver, cannot calculate earnings';
        case 'PAYOUTS_DISABLED':
            return 'Payouts are currently disabled. Contact support for help';
        case 'PAYOUTS_DISABLED_FOR_DRIVER':
            return 'Payouts are currently disabled for this driver account';
        case 'NO_SERVICES_AVAILABLE':
            return 'No services are available in your location at this time';
        case 'TOO_EARLY_TO_CANCEL':
            return 'Delivery cannot be canceled less than 1 hour before the event';
        case 'SCHEDULED_TOO_SOON':
            return `Scheduled too soon. Jobs must be booked at least ${Constants_1.minimumBookingWindowH} hours in advance`;
        case 'TRIP_NOT_PAYABLE':
            return 'Trip is not done; cannot be paid yet';
        default:
            return (0, capitalize_1.default)(reason.replace(/_/g, ' ').toUpperCase());
    }
}
exports.errorReasonMessage = errorReasonMessage;
